var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRetrievePlayersByTeamId, useRetrieveTeam, useRetrieveUserTeamPermissions, useUpdatePlayerMembership, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { playerDisplayName } from "../players/PlayerDisplayNameLink";
import { findPlayerById } from "../players/utils";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
export var EditMembership = function () {
    var _a;
    var _b = useNumericParams(), id = _b.id, playerId = _b.playerId;
    var navigate = useNavigate();
    var _c = __read(useState(""), 2), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useRetrieveUserTeamPermissions({ teamId: id }), permissions = _d.data, permsLoading = _d.isLoading, permsError = _d.error;
    var _e = (permissions || {}).canModify, canModify = _e === void 0 ? false : _e;
    var _f = useRetrieveTeam({ id: id, enabled: canModify }), team = _f.data, teamLoading = _f.isLoading, teamError = _f.error;
    var _g = useRetrievePlayersByTeamId({ teamId: id, enabled: canModify }), players = _g.data, playersLoading = _g.isLoading, playersError = _g.error;
    var player = players ? findPlayerById(players)(playerId) : undefined;
    var updateMembershipMutation = useUpdatePlayerMembership({
        teamId: id,
        onSuccess: function () {
            navigate("/teams/".concat(id, "/squad"));
        },
        onError: function () {
            setErrorMessage("Failed to update membership.");
        },
    });
    var _h = useForm({
        values: player
            ? {
                squadNumber: (_a = player.squadNumber) !== null && _a !== void 0 ? _a : null,
            }
            : { squadNumber: null },
    }), control = _h.control, handleSubmit = _h.handleSubmit;
    var onSubmit = function (data) {
        var _a;
        if (!player)
            return;
        updateMembershipMutation.mutate({
            playerId: player.id,
            squadNumber: (_a = data.squadNumber) !== null && _a !== void 0 ? _a : null,
        });
    };
    if (permsLoading || teamLoading || playersLoading) {
        return _jsx(Loading, {});
    }
    if (permsError || teamError || playersError) {
        return (_jsx(ErrorView, { error: permsError ||
                teamError ||
                playersError ||
                new Error("Failed to load.") }));
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (!player || !team) {
        return _jsx(NotFound, {});
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!errorMessage, message: errorMessage, onClose: function () { return setErrorMessage(""); } }), _jsx(Typography, { variant: "h4", sx: { mb: 1 }, children: "Edit Membership" }), _jsxs(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: ["Update team membership for ", playerDisplayName(player), " on ", team.name, "."] }), _jsxs(Box, { component: "form", role: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, sx: { maxWidth: 400 }, children: [_jsx(Controller, { name: "squadNumber", control: control, render: function (_a) {
                            var _b = _a.field, value = _b.value, onChange = _b.onChange, rest = __rest(_b, ["value", "onChange"]);
                            return (_jsx(TextField, __assign({}, rest, { value: value !== null && value !== void 0 ? value : "", onChange: function (e) {
                                    var raw = e.target.value.trim();
                                    onChange(raw === "" ? null : parseInt(raw, 10));
                                }, autoFocus: true, label: "Squad Number", type: "number", fullWidth: true, margin: "normal", inputProps: { min: 1, max: 99 }, helperText: "1\u201399, or leave empty to clear" })));
                        } }), _jsxs(Box, { sx: {
                            display: "flex",
                            justifyContent: "center",
                            gap: 2,
                            mt: 3,
                            mb: 2,
                        }, children: [_jsx(Button, { type: "submit", variant: "contained", color: "primary", size: "large", sx: { minWidth: 120 }, disabled: updateMembershipMutation.isLoading, children: "Save" }), _jsx(Button, { variant: "outlined", color: "secondary", size: "large", sx: { minWidth: 120 }, onClick: function () { return navigate("/teams/".concat(id, "/squad")); }, children: "Cancel" })] })] })] }));
};
